"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _SideCTA = _interopRequireDefault(require("./CTA/SideCTA/SideCTA"));
var _ButtonCTA = _interopRequireDefault(require("./CTA/ButtonCTA/ButtonCTA"));
var _useCTA = require("../hooks/app/useCTA");
var _SimpleBanner = _interopRequireDefault(require("./SimpleBanner/SimpleBanner"));
var _useConfig = _interopRequireDefault(require("../hooks/useConfig"));
var _r10SourceLibrary = require("r10-source-library");
var _useGuidedSellingStatus = require("../hooks/app/useGuidedSellingStatus");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
const buttonAppearanceMap = {
  primaryButton: 'primary',
  secondaryButton: 'secondary'
};
const CTAentryPoints = () => {
  const {
    content,
    appearance,
    showCTA,
    showExtendedCTA,
    showModifiedRibbon,
    onClickCTA
  } = (0, _useCTA.useCTA)();
  const showBanner = (0, _useConfig.default)('uiSettings.showBanner', false);
  const {
    openFloater,
    closeFloater,
    isFloaterOpen
  } = (0, _useGuidedSellingStatus.useGuidedSellingStatus)();
  const onToggleFloater = (0, _react.useCallback)(() => {
    isFloaterOpen ? closeFloater() : openFloater();
  }, [isFloaterOpen, openFloater, closeFloater]);
  const onCloseCTA = (0, _react.useCallback)(closedBy => {
    closeFloater(closedBy);
  }, [closeFloater]);
  const EntryButtonCTA = () => {
    return /*#__PURE__*/_react.default.createElement(_ButtonCTA.default, {
      appearance: buttonAppearanceMap[appearance],
      text: content.inFlowButtonText,
      launchFunction: onClickCTA
    });
  };
  const ConfigButtonCTA = () => {
    return showBanner ? /*#__PURE__*/_react.default.createElement("div", {
      style: {
        height: 'max-content'
      }
    }, /*#__PURE__*/_react.default.createElement(_SimpleBanner.default, null, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Heading, {
      size: 2,
      text: content.bannerText,
      noMargin: true,
      weight: 2,
      inverse: true
    }), /*#__PURE__*/_react.default.createElement(EntryButtonCTA, null))) : /*#__PURE__*/_react.default.createElement(EntryButtonCTA, null);
  };
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, showCTA ? appearance === 'ribbon' ? /*#__PURE__*/_react.default.createElement(_SideCTA.default, {
    title: content.popupTitle,
    content: content.popupText,
    secondaryButtonText: content.popupCancelButtonText,
    primaryButtonText: content.popupOkButtonText,
    sideText: content.ribbonText,
    floaterFunction: onToggleFloater,
    primaryButtonFunction: onClickCTA,
    secondaryButtonFunction: onCloseCTA,
    showPopUP: false,
    controlShowExtentedCTA: showExtendedCTA,
    showModifiedRibbon: showModifiedRibbon
  }) : null : null, ['primaryButton', 'secondaryButton'].includes(appearance) ? /*#__PURE__*/_react.default.createElement(ConfigButtonCTA, null) : null);
};
var _default = CTAentryPoints;
exports.default = _default;